import { Comment } from '../../../../../../models/CommentHistory';
import {
  Comment as ApiComment,
  Inline,
  InlineReply,
  Summary,
  SummaryReply,
} from '../../Models/ApiComment';
import { toLocation } from '../ApiLocationConverter';
import { toReaction } from '../ApiReactionConverter';
import { toUser } from '../ApiUserConverter';

export function toComment(comment: ApiComment): Comment {
  if (comment.type === 'inline' || comment.type === 'inline-reply') {
    return toInlineComment(comment);
  }

  return toSummaryComment(comment);
}

export function toInlineComment(comment: Inline | InlineReply): Comment {
  return {
    type: comment.type,
    uuid: comment.uuid,
    createdAt: comment.created_at ? new Date(comment.created_at) : undefined,
    updatedAt: comment.updated_at ? new Date(comment.updated_at) : undefined,
    path: comment.path,
    message: comment.message,
    outdatedAt: comment.outdated_at ? new Date(comment.outdated_at) : undefined,
    user: toUser(comment.user),
    reviewUUID: comment.review_uuid,
    inReplyToUUID: comment.in_reply_to_uuid,
    location: toLocation(comment.location),
    blameLocation: toLocation(comment.blame_location),
    category: comment.category,
    severity: comment.severity,
    reactions: comment.reactions?.map(toReaction) ?? [],
  };
}

export function toSummaryComment(comment: Summary | SummaryReply): Comment {
  return {
    type: comment.type,
    uuid: comment.uuid,
    createdAt: comment.created_at ? new Date(comment.created_at) : undefined,
    updatedAt: comment.updated_at ? new Date(comment.updated_at) : undefined,
    message: comment.message,
    state: comment.state,
    user: toUser(comment.user),
    reviewUUID: comment.review_uuid,
    inReplyToUUID: comment.in_reply_to_uuid,
    reactions: comment.reactions?.map(toReaction) ?? [],
  };
}
